import { Button, Hairline, Label, Select } from "@components";
import { Drawer } from "@components/Drawer";
import { Input } from "@components/Input";
import { FlowAPI } from "@providers/FlowAPI";
import { useState } from "react";

export const FlowFormDrawer = ({ visible, onSaved, onClose, folders }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [name, setName] = useState(null);
  const [folder, setFolder] = useState(null);

  const onSaveFlow = async () => {
    setIsSaving(true);
    const saveResponse = await FlowAPI.postFlow({ name, folder });
    setIsSaving(false);
    if (saveResponse.getErrors([]).length > 0) {
      alert({
        text: saveResponse.getErrors(["Ocorreu um erro ao salvar"])[0],
        buttonText: "Voltar",
      });
    } else {
      setName(null);
      onSaved && onSaved(saveResponse.getData());
    }
  };

  const selectFolder = (folder) => {
    setFolder(folder == -1 ? null : folder);
  };

  const folderOptions = (folders || []).map((folder) => ({
    label: folder.name,
    value: folder.id,
  }));

  return (
    <Drawer
      visible={visible}
      title="Novo fluxo"
      closeValidation={() => !isSaving}
      onClose={onClose}
      footer={
        <Button
          className="w-100"
          text="Salvar"
          design="primary"
          disabled={!name || isSaving}
          loading={isSaving}
          onClick={() => onSaveFlow()}
        />
      }
    >
      <Input
        value={name}
        label={"Fluxo"}
        onChange={async (text) => {
          setName(text.target.value);
        }}
        design="two"
      />

      <Hairline className="mt-20 mb-20" />
      <Label text={"Deseja agrupar este fluxo em uma pasta?"} />
      <Select
        label="Pasta"
        className="w-100"
        value={folder}
        options={[{ label: "Selecione", value: -1 }].concat(folderOptions)}
        onChange={(e) => selectFolder(e.target.value)}
      />
    </Drawer>
  );
};
